import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {Requisition, RequisitionCreateDTO, RequisitionResponse} from '../interfaces/requisition.interface';
import {AuthService} from "./auth.service";
import { LineSerialsRequest } from '../interfaces/inventory/serial.interface';

interface ApprovalItem {
    id: string;
    approvedQty: number;
    itemId: string;
    storeId: string;
    stockLotId?: string | null;
}

export const RequisitionService = {
    getLoggedInUserRequisitions: async (page: number = 0, size: number = 10): Promise<RequisitionResponse> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(`${ENDPOINTS.REQUISITION.LOGGED_IN_USER_REQUISITIONS(institutionId)}?page=${page}&size=${size}`);
        return response.data;
    },

    createRequisition: async (requisition: RequisitionCreateDTO): Promise<void> => {
        await axios.post(ENDPOINTS.REQUISITION.CREATE, requisition);
    },

    deleteRequisition: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.REQUISITION.DELETE(id));
    },

    getRequisitionById: async (id: string): Promise<Requisition> => {
        const response = await axios.get(ENDPOINTS.REQUISITION.GET_BY_ID(id));
        return response.data;
    },

    getPendingApprovalRequisitionsByInstitution: async (page: number = 0, size: number = 10): Promise<RequisitionResponse> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(`${ENDPOINTS.REQUISITION.PENDING_APPROVAL_REQUISITIONS_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`);
        return response.data;
    },

    getPendingIssueRequisitionsByInstitution: async (page: number = 0, size: number = 10): Promise<RequisitionResponse> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(`${ENDPOINTS.REQUISITION.PENDING_ISSUE_REQUISITIONS_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`);
        return response.data;
    },

    approveRequisition: async (requisitionId: string, items: ApprovalItem[]): Promise<void> => {
        await axios.put(`${ENDPOINTS.REQUISITION.BASE}/approve/${requisitionId}`, items);
    },

    rejectRequisition: async (requisitionId: string, reason: string): Promise<void> => {
        await axios.put(ENDPOINTS.REQUISITION.REJECT(requisitionId), { reason });
    },

    /** F6b: `serials` maps requisition detail id -> serials, for serial-tracked items. */
    issueRequisition: async (id: string, serials?: LineSerialsRequest): Promise<Requisition> => {
        const response = await axios.put(`${ENDPOINTS.REQUISITION.ISSUE(id)}`, serials);
        return response.data;
    },
};
